import { useEffect, useState } from "react";
import "../css/AppDownloadSection.css";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import UseAnimations from 'react-useanimations';
import arrowDown from 'react-useanimations/lib/arrowDown';
import colors from '../colors';

function AppDownloadSection()
{
    const [deferredPrompt, setDeferredPrompt] = useState(null);
    const [showInstallDialog, setShowInstallDialog] = useState(false);
    const [showIOSDialog,setShowIOSDialog] = useState(false);
    const [desktop, setDesktop] = useState(window.matchMedia("(min-width: 768px)").matches);
    


    useEffect(() => {

        window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
      return () => {
        window.removeEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
    };
    
  }, []);



  useEffect(() => {
    const handleAppInstalled = () => {
      // Hide the install dialog when the app is installed
      setShowInstallDialog(false);

      //ios cannot be installed automatically, show the install guide:
      const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

      if(isIOS)
        setShowIOSDialog(true);

      setDeferredPrompt(null);


    };

    window.addEventListener("appinstalled", handleAppInstalled);
    return () => {
      window.removeEventListener("appinstalled", handleAppInstalled);
    };
  }, []);


  const handleBeforeInstallPrompt = (event) => {
    event.preventDefault();
    // setTimeout(() => {
      setDeferredPrompt(event);
      setShowInstallDialog(true);
    // }, 3000); // 3 second delay
  };

  const handleInstallClick = () => {
    if (deferredPrompt) {

      deferredPrompt.prompt();
      deferredPrompt.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === "accepted") {
          console.log("User accepted the install prompt");

          //write in cache that user has installed the app:
          localStorage.setItem("FlickaAppInstalled", JSON.stringify(true));

        } else {
          console.log("User dismissed the install prompt");
        }
        setDeferredPrompt(null);
        setShowInstallDialog(false);
      });
    }
  };


    return(
        <div id="app-download-section">

<Dialog
        className="install-app"
        position="center"
        header="نصب اپلیکیشن"
        visible={showInstallDialog}
        onHide={() => setShowInstallDialog(false)}
      >
         <img src={require("../images/app.png")}  alt={process.env.REACT_APP_ALT}/>


        <p> می خواهید اپلیکیشن حرف به حرف را نصب کنید؟</p>
          <Button onClick={handleInstallClick}>بله!</Button>
          <Button id="cancel-install" onClick={() => setShowInstallDialog(false)} >نه، ممنون</Button>

         


      </Dialog> 

      <Dialog
        className="ios-guide"
        position="center"
        header="نصب اپلیکیشن"
        visible={showIOSDialog}
        onHide={() => setShowIOSDialog(false)}
        style={{width: !desktop ? "90%" : "40%"}}
      >

      <img className="install-logo" src={ require('../images/logo.png') }  alt={process.env.REACT_APP_ALT}/>
      <h5>
        وب اپلیکیشن حرف به حرف را به صفحه اصلی موبایل خود اضافه کنید
      </h5>
      <hr classname="dotted"/>
      <span style={{display:"flex",direction:"rtl",alignItems:"center"}}>
        <i className="pi pi-upload" style={{display:"flex",width:"10%"}}></i>
        <p> 1- در نوار پایین روی دکمه share بزنید</p>
        </span>

        <span style={{display:"flex",direction:"rtl",alignItems:"center"}}>
        <i className="pi pi-plus-circle" style={{display:"flex",width:"10%"}}></i>
        <p>
          2- در منوی بازشده، در قسمت پایین، گزینه add to Home Screen را انتخاب کنید
        </p>
        </span>

        <span style={{display:"flex",direction:"rtl",alignItems:"center",marginBottom:"30px"}}>
        <h5 style={{display:"flex",width:"10%",marginBottom: "0px"}}>Add</h5>
        <p>
          3- در مرحله بعد در قسمت بالا روی Add بزنید
        </p>
        </span>

        <Button> متوجه شدم</Button>

      </Dialog>
            <div>
          <h3 style={{marginBottom:"50px"}}>اپلیکیشن 
          &nbsp;
        {process.env.REACT_APP_PROJECT_NAME}
        &nbsp;
            
             را دانلود کنید</h3>
        </div>

        <div style={{display:"table",margin:"auto",marginBottom:"-30px"}}>
            <UseAnimations animation={arrowDown} size={80} fillColor={colors.primary} strokeColor="219B9D"/>
        </div>

        <div style={{display: desktop ? "flex" : "block"}}>

      <span className="app-col1" onClick={()=> setShowInstallDialog(true)}>

        <div><img src={require("../images/app.png")} alt={process.env.REACT_APP_ALT}/>
        <h6 style={{marginTop:"0px",marginBottom:"30px",fontSize:"16px"}}>
            تولید محتوا با
        &nbsp;
        {process.env.REACT_APP_PROJECT_NAME}
        &nbsp;
        </h6>
        </div>


      </span>


        </div>
        </div>
    );
}

export default AppDownloadSection;